import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { IGetFavoriteProfessionalsParams } from '../favoriteProfessionalsApi';
import { favoriteProfessionalsService } from '../favoriteProfessionalsService';
import { IFavoriteProfessional } from '../favoriteProfessionalsTypes';

type TUseFavoriteProfessionalsParams = IGetFavoriteProfessionalsParams & {
  enabled: boolean;
};

export function useFavoriteProfessionals(params: TUseFavoriteProfessionalsParams) {
  const dispatch = useDispatch();
  const query = useQuery<IFavoriteProfessional[]>({
    queryKey: ['favorite-professionals', params],
    queryFn: () => favoriteProfessionalsService.getFavoriteProfessionals(params),
    enabled: params.enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.data) {
      dispatch({ type: 'SET_FAVORITE_PROFESSIONALS', payload: query.data });
    }
  }, [query.data, dispatch]);

  return {
    ...query,
  };
}
